import { useState, useEffect } from 'react';
import { projectFirestore } from '../firebase';

const usePublic = (username, updated) => {
  const [docs, setDocs] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    let cancelled = false;

    async function fetchProfile() {
      if (!username) {
        setLoading(false);
        return;
      }

      setLoading(true);
      setError(null);
      setNotFound(false);

      try {
        const snapshot = await projectFirestore
          .collection('usernames')
          .doc(username)
          .get();

        if (cancelled) return;

        if (!snapshot.exists) {
          setDocs(null);
          setNotFound(true);
        } else {
          setDocs(snapshot.data());
          setNotFound(false);
        }
      } catch (err) {
        if (cancelled) return;
        console.error('usePublic:', err);
        setError(err.message || 'Failed to load profile');
        setDocs(null);
      } finally {
        if (!cancelled) setLoading(false);
      }
    }

    fetchProfile();

    return () => {
      cancelled = true;
    };
  }, [username, updated]);

  return { docs, loading, error, notFound };
};

export default usePublic;
